import { NgModule } from '@angular/core';
import { DragDropDirective } from './drag-drop.directive';

@NgModule({
  exports: [DragDropDirective],
  declarations: [DragDropDirective],
})
export class DragAndDropDirectiveModule {}
